<template>
  <!-- LOGIN BOX START -->
  <div class="loginBox">

    <div class="bgLogin"></div>

    <div class="logo">
      <img src="@/assets/images/logo.svg" alt="" />
    </div>

    <div class="loginForm">
      <form action="" @submit.prevent="authenticate()">
        <div class="visible" v-if="isActive" style="color:red">{{$t('wronglp')}}</div><!-- +/- class visible -->
        <div class="loginInput">
          <input type="text" :placeholder="$t('username')" v-model="username"/>
        </div>
        <div class="loginInput">
          <input type="password" :placeholder="$t('password')" v-model="password"/>
        </div>
        <div class="loginSubmit">
          <input type="submit" value="GO" />
        </div>
      </form>
    </div>

    <div class="flag">
      <div><img src="@/assets/images/ru.png" alt="" @click="$i18n.locale = 'ru'; cookies.set('lang', 'ru', { expires: 30 })"></div>
      <div><img src="@/assets/images/uk.png" alt="" @click="$i18n.locale = 'en'; cookies.set('lang', 'en', { expires: 30 })"></div>
      <!-- <div><img src="@/assets/images/georgia.png" alt=""></div> -->
    </div>

  </div>
  <!-- LOGIN BOX STOP -->
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'Authentication',
  props: {
    msg: String
  },
  computed: {
    cookies: function(){
      return Cookies
    }
  },
  data:   function(){ return {
      username: "",
      password: "",
      isActive: false
    }
  },
  methods: {
    authenticate(){
      this.$store.dispatch('login', {user: this.username, pw: this.password}).then((response)=>{
        this.$store.dispatch('apirequest', {token: response.data.token, name: "game/kass"}).then((responses) => {
            this.$store.state.Time = (this.$store.state.game.Time - Date.now()) / 1000;
          });
        this.$store.dispatch('apirequest', {token: response.data.token, name: "teams/"}); 
        this.$store.dispatch('apirequest', {token: response.data.token, name: "jackpot/"});
        Cookies.set('username', this.username, { expires: 1 });
        Cookies.set('password', this.password, { expires: 1 });
        this.$router.push({name: 'MainTab'}); 
      }).catch(function (error) {
        return this.isActive = true
      });
    }
  },
  
};
</script>